import { create } from "zustand";
import { API_ENDPOINTS, apiFetchJson } from "@/lib/api";

export interface ServerStatus {
    id: string;
    name: string;
    game: string;
    status: "online" | "offline";
    players: { current: number; max: number };
    ip: string;
    port: number;
    domain?: string;
    version?: string;
    description?: string;
    features?: string[];
    tags?: string[];
    rcon_enabled?: boolean;
    modded?: boolean;
    difficulty?: string;
}

interface ServersStore {
    servers: ServerStatus[];
    loading: boolean;
    error: string | null;
    fetchServers: () => Promise<void>;
}

export const useServersStore = create<ServersStore>((set, _get) => ({
    servers: [],
    loading: false,
    error: null,

    fetchServers: async () => {
        set({ loading: true, error: null });

        try {
            const data = await apiFetchJson<any>(API_ENDPOINTS.SERVERS);
            const servers = Array.isArray(data) ? data : data?.servers || [];
            set({ servers: Array.isArray(servers) ? servers : [], loading: false });
        } catch (error) {
            console.warn("API non disponibile:", error);
            set({ servers: [], loading: false, error: "API non disponibile" });
        }
    },
}));
